var _style, _rect, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvataricon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1248.5 1249.2",
    style: {
      enableBackground: "new 0 0 1248.5 1249.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6A632;}\n\t.st1{fill:#E73964;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#F4F4F4;}\n\t.st4{fill:#A8A8A8;}\n\t.st5{fill:url(#SVGID_00000163056692790370805190000007536466936129706150_);}\n\t.st6{fill:url(#SVGID_00000000918074979296743050000017653323232176452511_);}\n\t.st7{fill:url(#SVGID_00000181809889306515315330000016151749432512236983_);}\n\t.st8{fill:url(#SVGID_00000015356013186846208690000000732915183428538250_);}\n\t.st9{fill:#EAEAEA;}\n\t.st10{fill:#F9F7F7;}\n\t.st11{fill:#A0A0A0;}\n\t.st12{fill:url(#SVGID_00000003797397080241699600000004254531732704259465_);}\n\t.st13{fill:url(#SVGID_00000068653371550344481730000012330889558201908367_);}\n\t.st14{fill:url(#SVGID_00000028291545367075639800000010195621218791999672_);}\n\t.st15{fill:#FFFFFF;}\n\t.st16{fill:url(#SVGID_00000070837744592732409060000009097551477787823003_);}\n\t.st17{fill:url(#SVGID_00000084505875227839527240000009611602005080800912_);}\n\t.st18{fill:url(#SVGID_00000022520875616356586330000007847661970055225473_);}\n\t.st19{fill:url(#SVGID_00000071527734010165522360000005388290568931604128_);}\n\t.st20{fill:url(#SVGID_00000021109108939048324380000010667286005064092590_);}\n\t.st21{fill:url(#SVGID_00000067232838019475864550000017447968046462340010_);}\n\t.st22{fill:url(#SVGID_00000090978530434567876660000005016763499337018504_);}\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1248.5,
    height: 1249.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.272,
    y1: 1037.0559,
    x2: 842.2791,
    y2: 1037.0559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A1A1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05779973,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1872,
    style: {
      stopColor: "#D4D4D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3108,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4253,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6449,
    style: {
      stopColor: "#FCFCFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7549,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8598,
    style: {
      stopColor: "#DFDFDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9609,
    style: {
      stopColor: "#C6C6C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABAB9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M842.3,1122.3c-150.4-53.3-302.4-51.4-454,0V980.1c152.6-39,303.8-36.5,454,0V1122.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129912325781210493600000010618271859618006155_",
    gradientUnits: "userSpaceOnUse",
    x1: 624.2674,
    y1: 1276.5345,
    x2: 624.2674,
    y2: 805.3664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00497512,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5527,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7663,
    style: {
      stopColor: "#D5D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9648,
    style: {
      stopColor: "#BFBFBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABAB9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129912325781210493600000010618271859618006155_)"
    },
    d: "M778.4,859 c-11.4-0.1,9.1,144.1,19.6,178.7c14,46.1,101.4,81.9,191.2,109.1c41.2,12.5,117.4,67.5,127.9,88.8c6,12.2,5.7,13.6,5.7,13.6H125.7 l62.8-60.3c19.4-18.6,43.2-31.9,69.2-38.6l30.6-7.9l37.4-17.6c7.2-3.4,14-7.5,20.3-12.3l76.8-58.2c0,0,24.1-30.1,22.1-75.6 c-2-45.5-2-119.5-2-119.5H778.4z"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "558.1,1248 673.6,1248 639.9,1205.5 593.1,1205.5  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M604.9,1104.9l-63.7,63.7c0,0,12.7,52.8,41.2,47.5c2.7-0.5-0.2,2.5,12.7,8.3c13.7,6.1,31-0.2,44-2 c16.5-2.3,31-12.1,39.4-26.5l15.6-26.6l-60.6-61.8L604.9,1104.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000057115742976634712400000002045811066652139146_",
    cx: 1587.7878,
    cy: 1453.0616,
    r: 244.0521,
    gradientTransform: "matrix(0.4897 0 0 0.49 -263.42 395.4927)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0928131,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2404,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3971,
    style: {
      stopColor: "#D5D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5649,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7517,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#F2F2F2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057115742976634712400000002045811066652139146_)"
    },
    d: "M358.3,1104.3c0,0,104.9,86.2,178.5,94.9 c5.9,0.7,21.2,1.2,23.7-2.5l57.7-89.3l-215-70.6L358.3,1104.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000172438429903041092690000008733930763240805821_",
    cx: 1983.5397,
    cy: 1436.3981,
    r: 254.2535,
    gradientTransform: "matrix(0.4897 0 0 0.49 -263.42 395.4927)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0928131,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2404,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3971,
    style: {
      stopColor: "#D5D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5649,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7517,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#F2F2F2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172438429903041092690000008733930763240805821_)"
    },
    d: "M879.1,1105.6c0,0-104.9,86.2-178.5,94.9 c-5.9,0.7-21.2,1.2-23.7-2.5l-57.7-89.3l215-70.6L879.1,1105.6z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M380.6,726.5c0,0,31.8,155.9,111.8,204.3c124.9,75.6,210.7,11.5,210.7,11.5s99.7-89.3,116-141.9 c14.6-47,19.7-73.9,19.7-73.9s13.2,0,21.9-10.9c8.8-10.9,11-80.4,17.5-100c6.6-19.6,11-52.2-11-50c-21.9,2.2-32.9,39.1-32.9,39.1 s41.4-142.1,28.2-181.3c-13.2-39.1-26.1-44.8-78.7-77.4c-52.6-32.6-78.8-58.4-111.1-47.6c-32.3,10.9-183.1,17.7-224.7,2.5 c-41.7-15.2-80.8,112.3-87.4,144.9c-6.6,32.6,17.6,132.7,19.8,158.8c2.2,26.1,2.2,26.1,2.2,26.1s-15.3-69.5-28.5-73.9 c-13.2-4.3-37.3-4.3-32.9,47.8c4.4,52.2,9.7,11.8,28.5,108.7C360.9,769.9,380.6,726.5,380.6,726.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M388,981.1c0,0-19.1,112.4-31.4,115.5c-12.2,3.2,135.8,76,190.3,83c0,0,32.7-56.6,69.4-73.7 C616.3,1106,395.6,1031.2,388,981.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M842.7,980.1c0,0,20.1,112.2,32.2,115.2c12.1,3-133.5,77.5-187.3,85.1c0,0-32.9-56.2-69.4-72.9 C618.3,1107.4,835.8,1030.2,842.7,980.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382,596.9c0,0-18.2-57.3-14.2-86c4.1-28.7-16.2-145.3,52.7-165.8c68.9-20.5,125.6,2,143.9-2 c18.2-4.1,89.6-37.3,115.5-30.7c29.3,7.4,129.7,88,154,88c0,0,10.3,60.4,16.4,70.6c6.1,10.2-6.3,93.2-6.3,105.4 c0,12.3,0,18.4,4.1,30.7c0,0,6.1-22.5,8.1-36.8c2-14.3,26.3-51.2,26.3-51.2s20.3-122.8,16.2-131c-4.1-8.2,20.3-18.4-16.2-86 C846,234.6,683.9,136.3,617,128.2c-66.9-8.2-160.1,0-198.6,106.4c0,0-101.3,22.5-115.5,128.9c-14.2,106.4,64.8,182.2,64.8,214.9 s10.1,51.2,10.1,51.2L382,596.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M841.4,600.5c1.8,5-16.8-3-16.8-3s-22.7,66.9-34.9,70.3c-12.2,3.3-131.6,4.2-139.7-6.1 c-6-7.5-14.7-35.5-19-49.9c-18-10.9-34.3-4.8-45.8,3.6c-4.5,15.1-12.4,39.3-17.9,46.3c-8.2,10.3-127.6,9.5-139.7,6.1 c-12.2-3.3-34.9-70.3-34.9-70.3s-18.7,8-16.9,3c3-8.3-4.4-24-10.3-34c10.1,9.1,24.3,7.3,24.3,7.3s5.7-11,24.4-11.6 c47.9-1.5,133.2-8.1,181.5,12.7c15.4,2.2,18,1.5,26,0c48.3-20.8,133.6-14.2,181.5-12.7c18.6,0.6,24.4,11.6,24.4,11.6 s14.3,1.8,24.3-7.3C845.8,576.4,838.4,592.2,841.4,600.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M564.3,577.1c0,0-58.7-16.2-142.3-2.5c-39.4,6.5,7.5,81.2,8.7,82.4c1.2,1.2,68.7,11.2,126.1-1.2 C575,651.9,581.8,575.9,564.3,577.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M653.6,577.1c0,0,58.7-16.2,142.3-2.5c39.4,6.5-7.5,81.2-8.7,82.4c-1.2,1.2-68.7,11.2-126.1-1.2 C643,651.9,636.1,575.9,653.6,577.1z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M849.8,559.1c-1.6,3-3.5,5.4-5.6,7.3C848.6,559,852.1,554.8,849.8,559.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M357.9,566.5c-2.1-1.9-4-4.3-5.6-7.3C350,554.8,353.5,559,357.9,566.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvataricon03);
export default __webpack_public_path__ + "static/media/avatar icon-03.bfb2bb974b82973d74f45caa3e4366a9.svg";
export { ForwardRef as ReactComponent };